import { useNavigate } from "react-router-dom";
import AuthService from "../../../../../base/services/authentication.service";
import { UserRolesEnum } from "../../../../auth/userRoles.enum";
import { SessionService } from "../../../../../base/services/session.service";
import { LocalStorageService } from "../../../../../base/services/local-storage.service";

// Enter Workspace function for consultant
const useEnterWorkspaceForStaff = () => {
   const navigate = useNavigate();

   const enterWorkspace = (workspaceId) => {
      //#todo alperen org and staffs will be redirected to Assesment list
      SessionService.setItem("workspaceID", workspaceId);
      LocalStorageService.setItem("workspaceID", workspaceId);
      if (AuthService.isAuthorized([UserRolesEnum.Consultant])) {
         navigate("/workspace/assessment/guided-assessment/list", {
            state: { fromApp: true, workspaceId: workspaceId }
         });
      } else {
         navigate("/workspace/results/results", {
            state: { fromApp: true, workspaceId: workspaceId }
         });
      }
   };

   return enterWorkspace;
};

// Enter Workspace function for simple users
const useEnterWorkspaceForOthers = () => {
   const navigate = useNavigate();
   const isStaff = AuthService.isAuthorized([UserRolesEnum.Staff]);

   const enterWorkspace = (workspaceId) => {
      //#todo alperen org and staffs will be redirected to Assesment list
      SessionService.setItem("workspaceID", workspaceId);
      if (isStaff) {
         navigate("/workspace/my-performance", {
            state: { fromApp: true, workspaceId: workspaceId }
         });
      } else {
         navigate("/workspace/assessment/self-assessment/", {
            state: { fromApp: true, workspaceId: workspaceId }
         });
      }
   };

   return enterWorkspace;
};

export { useEnterWorkspaceForStaff, useEnterWorkspaceForOthers };
